var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-breadcrumbs',{staticClass:"py-3",attrs:{"large":"","items":_vm.cumps},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('v-breadcrumbs-item',{staticClass:"breadcrumb-item",attrs:{"disabled":item.disabled},on:{"click":function($event){return _vm.$router.go(item.to)}}},[_vm._v(" "+_vm._s(item.text)+" ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }